import {teamConstants} from "../_constants/team.constants";

export const teams = (state = {}, action) => {
    switch (action.type) {
        case teamConstants.LIST_REQUEST: {
            return {
                loading: true,
            };
        }
        case teamConstants.LIST_SUCCESS: {
            return {
                teams: action.teams,
            }
        }
        case teamConstants.LIST_FAILURE: {
            return {
                error: action.error,
            }
        }

        case teamConstants.CREATE_REQUEST: {
            return {
                ...state,
                creating: true,
            };
        }
        case teamConstants.CREATE_SUCCESS: {
            const { team } = action;

            return {
                teams: [...(state.teams ?? []), { ...team, justCreated: true }],
            }
        }
        case teamConstants.CREATE_FAILURE: {
            return {
                createError: action.error,
            }
        }

        case teamConstants.REMOVE_REQUEST: {
            return {
                ...state,
                teams: [...state.teams ?? []].map(team => {
                    return team.id === action.teamId
                        ? { ...team, deleting: true }
                        : team;
                }),
                removing: true,
            };
        }
        case teamConstants.REMOVE_SUCCESS: {
            return {
                ...state,
                teams: [...state.teams ?? []].filter(team => team.id !== action.teamId),
                removing: false,
            }
        }
        case teamConstants.REMOVE_FAILURE: {
            return {
                ...state,
                teams: [...state.teams ?? []].map(team => {
                    return team.deleting
                        ? { ...team, deleting: undefined }
                        : team;
                }),
                removing: false,
                removingError: action.error,
            }
        }
        case teamConstants.UPLOAD_LOGO_REQUEST:
            return {
                ...state,
                uploadingLogo: true
            };
        case teamConstants.UPLOAD_LOGO_SUCCESS:
            return {
                ...state,
                uploadingLogo: false,
                logoUrl: action.logoUrl.key
            };
        case teamConstants.UPLOAD_LOGO_FAILURE:
            return {
                ...state,
                uploadingLogo: false,
                error: action.error
            };
    }

    return state;
}
